export default "__VITE_ASSET__CrUG0O8X__"